import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useCurrentPregnancyChartsDataContext } from './hooks/useCurrentPregnancyChartsDataContext';

export const PregnancyTypes = () => {
    const { chartData } = useCurrentPregnancyChartsDataContext();

    return (
        <Donut
            title={'Tipo de Gravidez'}
            subtitles={chartData?.pregnancyTypes?.map((item) => item.description)}
            chartData={chartData?.pregnancyTypes || []}
            colors={defaultColors.slice(0, chartData?.pregnancyTypes?.length) || []}
            height={350}
            className='aligned-container'
        />
    );
};
